export default theme => ({
    messageRow: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1, 0),
    },
    messageLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        marginBottom: theme.spacing(1),
    },
    messageGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'inherit',
    },
    humanMessageGroup: {
        // Indent to align bubble and actions under the name, not the avatar.
        // Matches: avatar width (1.5rem) + gap (spacing 0.5) + labelText marginLeft (spacing 0.5)
        paddingLeft: `calc(1.5rem + ${theme.spacing(1)})`,
    },
    labelAvatar: {
        width: '1.5rem',
        height: '1.5rem',
        fontSize: '0.7rem',
    },
    labelText: {
        fontWeight: 600,
        marginLeft: theme.spacing(0.5),
    },
    userBubble: {
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.spacing(2, 2, 0.5, 2),
        backgroundColor: '#E4E5FF',
        color: theme.palette.text.primary,
    },
    assistantBubble: {
        color: theme.palette.text.primary,
    },
    humanBubble: {
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.spacing(0.5, 2, 2, 2),
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
    },
    content: {
        color: 'inherit',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
    thinking: {
        color: theme.palette.grey[600],
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    thinkingText: {
        animation: '$thinkingFadeIn 0.4s ease',
        fontStyle: 'italic',
    },
    markdown: {
        ...theme.typography.body1,
        color: 'inherit',
        wordBreak: 'break-word',
        lineHeight: 1.7,
        '& p': {
            color: 'inherit',
            lineHeight: 'inherit',
            margin: theme.spacing(0, 0, 1.5),
            '&:last-child': { marginBottom: 0 },
        },
        '& h1': { ...theme.typography.h3, margin: theme.spacing(0, 0, 1) },
        '& h2': { ...theme.typography.h4, margin: theme.spacing(0, 0, 1) },
        '& h3': { ...theme.typography.h5, margin: theme.spacing(0, 0, 1) },
        '& h4': { ...theme.typography.h6, margin: theme.spacing(0, 0, 1) },
        '& ul': {
            color: 'inherit',
            listStyle: 'disc',
            margin: theme.spacing(0, 0, 1.5),
            paddingLeft: theme.spacing(3),
        },
        '& ol': {
            color: 'inherit',
            listStyle: 'decimal',
            margin: theme.spacing(0, 0, 1.5),
            paddingLeft: theme.spacing(3),
        },
        '& li': {
            marginBottom: theme.spacing(0.75),
            paddingLeft: theme.spacing(0.5),
        },
        '& strong': {
            fontWeight: 700,
        },
        '& code': {
            fontFamily: theme.typography.fontFamily || 'monospace',
            backgroundColor: theme.palette.grey[200],
            padding: theme.spacing(0.25, 0.5),
            borderRadius: 4,
            fontSize: '0.85em',
        },
        '& pre': {
            backgroundColor: theme.palette.grey[200],
            padding: theme.spacing(1.5),
            borderRadius: 4,
            overflow: 'auto',
            margin: theme.spacing(0, 0, 1.5),
            '& code': {
                backgroundColor: 'transparent',
                padding: 0,
            },
        },
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
        '& blockquote': {
            borderLeft: `3px solid ${theme.palette.grey[300]}`,
            margin: theme.spacing(0, 0, 1.5),
            padding: theme.spacing(0.5, 0, 0.5, 1.5),
            color: theme.palette.text.secondary,
        },
    },
    actions: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(1),
    },
    actionIcon: {
        fontSize: '1rem',
    },
    actionsTimestamp: {
        alignSelf: 'center',
        color: theme.palette.action.active,
    },
    citationsWrapper: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(0.5),
        marginTop: theme.spacing(0.25),
        overflow: 'hidden',
        // Take the natural width of the collapsed toggle / expanded card
        // instead of stretching to fill the actions row.
        alignSelf: 'flex-start',
    },
    citationsToggle: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        cursor: 'pointer',
        padding: theme.spacing(1, 1.5),
        color: theme.palette.text.primary,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    citationsIcon: {
        fontSize: '1rem',
    },
    citationsList: {
        padding: theme.spacing(1, 1.5),
    },
    citationItem: {
        padding: theme.spacing(0.5, 0),
    },
    citationText: {
        color: theme.palette.text.secondary,
        wordBreak: 'break-word',
    },
    citationNumber: {
        marginRight: theme.spacing(0.5),
    },
    '@keyframes blink': {
        '0%, 100%': { opacity: 1 },
        '50%': { opacity: 0 },
    },
    '@keyframes thinkingFadeIn': {
        '0%': { opacity: 0, transform: 'translateY(4px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' },
    },
});
